export const ACCEPTED_FILE_EXTENSIONS = [
  '.csv',
  '.doc',
  '.docx',
  '.pdf',
  '.txt',
  '.xls',
  '.xlsx',
]
export const ACCEPTED_FILE_TYPES = ['image/*']
export const ADDRESS_MAX_LENGTH = 128
export const CANCELLATION_REASON_MAX_LENGTH = 50
export const CONTACT_MAX_NAME_LENGTH = 100
export const CURRENCY_MAX_LENGTH = 14
export const EMAIL_MAX_LENGTH = 254
export const ITEM_NAME_MAX_LENGTH = 255
export const ITEM_UNIT_MAX_LENGTH = 50
export const PASSWORD_MAX_LENGTH = 200
export const PASSWORD_MIN_LENGTH = 8
export const POSTAL_CODE_MAX_LENGTH = 20
export const PROJ_NAME_MAX_LENGTH = 128
export const PROJ_NUM_MAX_LENGTH = 64
export const REFERENCE_NAME_MAX_LENGTH = 48
export const SELECT_MAX_LENGTH = 100
export const SUPPLIER_REFERENCE_MAX_LENGTH = 50
export const TEXTAREA_MAX_LENGTH = 5000
export const VENDOR_NAME_MAX_LENGTH = 254
export const DELIVERY_DATE_REQUIRED_VALUES = ['am', 'pm', 'sp']
export const DELIVERY_REQUIRED_VALUES = DELIVERY_DATE_REQUIRED_VALUES.concat(['tbd'])
export const PHONE_MASK = '###-###-####'
export const phoneNumberValidation = (value) => !value || value.length === PHONE_MASK.length
export const addressFields = ['address', 'city', 'country', 'postal_code', 'province']
export const UNIT_PRICE_DECIMALS = 6
export const QUANTITY_DECIMALS = 2
export const AUTH_VERSION = 'v1'
